<template>
  <ul>
    <li v-for="(description, index) in formatDescription" :key="index">
      {{ description }}
    </li>
  </ul>
</template>

<script>
export default {
  name: "DoeList",
  props: {
    description: {
      type: [Array, String],
      required: false
    }
  },
  computed: {
    formatDescription() {
      if (!Array.isArray(this.description)) {
        return new Array(this.description);
      } else {
        return this.description;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
ul {
  @apply mt-2 pl-4;
  list-style-type: disc;
}
li {
  @apply font-sans font-light leading-tight max-w-4xl mb-3 text-base text-black;
}
</style>
